// Mutations
import { MUTATIONS_LOCALE } from './mutations';

// Constants
import { resolveLocale, storeLocale } from '@/constants/locale-constants';

export default {
  setLocale({ commit }, locale) {
    // Só idioma da lista entra no estado e no localStorage (review de segurança do i18n)
    const safeLocale = resolveLocale(locale);

    storeLocale(safeLocale);

    commit(MUTATIONS_LOCALE.SET_LOCALE, safeLocale);
  }
};
